import { ReactElement } from 'react';
import cn from 'classnames';
import styles from './Close.module.scss';
import { Icon } from '../Icon/Icon';

interface CloseProps {
    onClick: () => void;
    className?: string;
}

export const Close = ({ onClick, className, ...props }: CloseProps): ReactElement | null => {
    return (
        <button onClick={onClick} className={cn(styles.wrapper, className)} {...props}>
            <Icon name="close" />
        </button>
    );
};
